"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Trend = _interopRequireDefault(require("@rsuite/icon-font/lib/charts/Trend"));

// Generated by script, don't edit it please.
var Trend = (0, _createSvgIcon["default"])({
  as: _Trend["default"],
  ariaLabel: 'trend',
  category: 'charts',
  displayName: 'Trend'
});
var _default = Trend;
exports["default"] = _default;
module.exports = exports.default;